import { getDeviceDimensionsInfo } from '@utils/common';

import { useEffect, useMemo, useState } from 'react';

function useWindowSize() {
	const windowExist = typeof window !== 'undefined';

	const [size, setSize] = useState<{ height: number; width: number }>({
		height: windowExist ? window.innerHeight : 0,
		width: windowExist ? window.innerWidth : 0,
	});

	useEffect(() => {
		if (!windowExist) return;

		function resizeCallback() {
			setSize({
				height: window.innerHeight,
				width: window.innerWidth,
			});
		}

		window.addEventListener('resize', resizeCallback);

		return () => {
			window.removeEventListener('resize', resizeCallback);
		};
	}, [windowExist]);

	const deviceDimensionsInfo = useMemo(() => {
		return getDeviceDimensionsInfo(size.height, size.width);
	}, [size]);

	return { ...deviceDimensionsInfo };
}

export default useWindowSize;
